import RoutesApp from './Routes/routes';

export default function App() {
  
  return(
    <div className="App">
        <RoutesApp />
    </div>
  );
}